<div class="row mt-3" [formGroup]="form">
  <div class="col-md-12">


    <div class="row">
      <div class="col-md-12">
        <div class="mb-3">
          <span i18n>Personenbezogene Daten des Familienangehörigen, der Unionsbürger oder Bürger des EWR oder der Schweiz ist oder der als Staatsangehöriger des Vereinigten Königreichs Begünstigter des Austrittsabkommens zwischen der EU und dem Vereinigten Königreich ist.</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="mb-3">
          <label for="referenz.verwandtschaftsbeziehungBeiEUFreizuegigkeit.value" i18n [class.mandatory]="isMandatory('verwandschaftsbeziehung')">Verwandtschaftsverhältnis:</label>
          <select id="referenz.verwandtschaftsbeziehungBeiEUFreizuegigkeit.value"
                  class="form-select form-select-sm"
                  [class.is-invalid]="errorClassRequired(form.controls['verwandschaftsbeziehung'])"
                  formControlName="verwandschaftsbeziehung"
                  [ngbPopover]="popover_referenz_verwandtschaftsbeziehungBeiEUFreizuegigkeit_value"
                  appSaveLastFocussed
          >
            <option value="" selected></option>
            <option *ngFor="let listItem of verwandschaftsbeziehungListItems"
                    value="{{ listItem.key }}">{{ listItem.value }}
            </option>
          </select>
          <ng-template #popover_referenz_verwandtschaftsbeziehungBeiEUFreizuegigkeit_value>
            <app-assistant (assistantDisabled)="disableAssistant()">
              <span i18n>Bitte tragen Sie hier das Verwandtschaftsverhältnis des/der Antragstellenden zum/zur EU-Staatsangehörigen oder Staatsangehörigen des EWR oder der Schweiz ein.</span>
            </app-assistant>
          </ng-template>
        </div>
      </div>

      <div class="col-md-4">
        <div class="mb-3">
          <label for="referenz.ansprechpartner.familienname" i18n [class.mandatory]="isMandatory('familienname')">Familienname:</label>
          <input id="referenz.ansprechpartner.familienname"
                 type="text"
                 appToUpperCase
                 [attr.maxlength]="getMaxLength('familienname')"
                 class="form-control form-control-sm"
                 [class.is-invalid]="errorClassRequired(form.controls['familienname'])"
                 formControlName="familienname"
                 [ngbPopover]="popover_referenz_ansprechpartner_familienname"
                 appSaveLastFocussed
          >
        </div>
        <ng-template #popover_referenz_ansprechpartner_familienname>
          <app-assistant (assistantDisabled)="disableAssistant()">
            <span i18n>Bitte tragen Sie hier den Familiennamen des/der EU-Staatsangehörigen oder Staatsangehörigen des EWR oder der Schweiz ein (wie im Reisedokument oder Personalausweis angegeben). Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
          </app-assistant>
        </ng-template>
      </div>

      <div class="col-md-4">
        <div class="mb-3">
          <label for="referenz.ansprechpartner.vorname" i18n [class.mandatory]="isMandatory('vorname')">Vorname(n):</label>
          <input id="referenz.ansprechpartner.vorname"
                 type="text"
                 appToUpperCase
                 [attr.maxlength]="getMaxLength('vorname')"
                 class="form-control form-control-sm"
                 [class.is-invalid]="errorClassRequired(form.controls['vorname'])"
                 formControlName="vorname"
                 [ngbPopover]="popover_referenz_ansprechpartner_vorname"
                 appSaveLastFocussed
          >
        </div>
        <ng-template #popover_referenz_ansprechpartner_vorname>
          <app-assistant (assistantDisabled)="disableAssistant()">
            <span i18n>Bitte tragen Sie hier den/die Vornamen des/der EU-Staatsangehörigen oder Staatsangehörigen des EWR oder der Schweiz ein (wie im Reisedokument oder Personalausweis angegeben). Folgende (Sonder-)Zeichen sind zulässig: A..ZÄÖÜß'/- +.blank. Ziffern können nicht eingegeben werden.</span>
          </app-assistant>
        </ng-template>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="mb-3">
          <label for="referenz.ansprechpartner.geburtsdatum" i18n [class.mandatory]="isMandatory('geburtsdatum')"
          >Geburtsdatum (TT.MM.JJJJ):</label>
          <input id="referenz.ansprechpartner.geburtsdatum"
                 type="text"
                 appDynamicDateMaxLength
                 appFixDate="past" unknownReplacement="00"
                 class="form-control form-control-sm"
                 [class.is-invalid]="errorClassRequired(form.controls['geburtsdatum'])"
                 formControlName="geburtsdatum"
                 [ngbPopover]="popover_referenz_ansprechpartner_geburtsdatum"
                 appSaveLastFocussed
          >
        </div>
        <ng-template #popover_referenz_ansprechpartner_geburtsdatum>
          <app-assistant (assistantDisabled)="disableAssistant()">
            <span i18n>Bitte tragen Sie hier das Geburtsdatum (im Format TT.MM.JJJJ) des/der EU-Staatsangehörigen oder Staatsangehörigen des EWR oder der Schweiz ein (wie im Reisedokument oder Personalausweis angegeben).</span>
          </app-assistant>
        </ng-template>
      </div>

      <div class="col-md-4">
        <div class="mb-3">
          <label for="referenz.ansprechpartner.staatsangehoerigkeit" i18n [class.mandatory]="isMandatory('staatsangehoerigkeit')"
          >Derzeitige Staatsangehörigkeit:</label>
          <select id="referenz.ansprechpartner.staatsangehoerigkeit"
                  class="form-select form-select-sm"
                  [class.is-invalid]="errorClassRequired(form.controls['staatsangehoerigkeit'])"
                  formControlName="staatsangehoerigkeit"
                  [ngbPopover]="popover_referenz_ansprechpartner_staatsangehoerigkeit"
                  appSaveLastFocussed
          >
            <option value="" selected></option>
            <option *ngFor="let listItem of staatsangehoerigkeitListItems"
                    value="{{ listItem.key }}">{{ listItem.value }}
            </option>
          </select>
          <ng-template #popover_referenz_ansprechpartner_staatsangehoerigkeit>
            <app-assistant (assistantDisabled)="disableAssistant()">
              <span i18n>Bitte tragen Sie hier die Staatsangehörigkeit des/der EU-Staatsangehörigen oder Staatsangehörigen des EWR oder der Schweiz ein.</span>
            </app-assistant>
          </ng-template>
        </div>
      </div>

      <div class="col-md-4">
        <div class="mb-3">
          <label for="referenz.passnummer" i18n [class.mandatory]="isMandatory('passnummer')">
            Nummer des Reisedokuments oder des Personalausweises:</label>
          <input id="referenz.passnummer"
                 type="text"
                 appToUpperCase
                 [attr.maxlength]="getMaxLength('passnummer')"
                 class="form-control form-control-sm"
                 [class.is-invalid]="errorClassRequired(form.controls['passnummer'])"
                 formControlName="passnummer"
                 [ngbPopover]="popover_referenz_passnummer"
                 appSaveLastFocussed
          >
          <ng-template #popover_referenz_passnummer>
            <app-assistant (assistantDisabled)="disableAssistant()">
              <span i18n>Bitte tragen Sie hier die Nummer des Reisedokuments oder des Personalausweises des/der EU-Staatsangehörigen oder Staatsangehörigen des EWR oder der Schweiz ein.</span>
            </app-assistant>
          </ng-template>
        </div>
      </div>
    </div>

  </div>
</div>
